import { render, staticRenderFns } from "./ScoringModelCheckParamEdit.vue?vue&type=template&id=6ce701ba&lang=pug&"
import script from "./ScoringModelCheckParamEdit.vue?vue&type=script&lang=js&"
export * from "./ScoringModelCheckParamEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports